<template>
    <div id="categoryFilterColumn" class="mb-4">
        <div class="filter" v-for="(item, index) in categories" :key="index">
            <button :class="['btn', 'btn-block', 'text-left', 'mb-2', ' text-truncate', 'text-nowrap', { 'category-bar-selected': isSelectedCategory(item), 'category-bar-not-selected': !isSelectedCategory(item) }]" @click="selectCategory(item)">
                <template v-if="item">
                    <span :style="{ backgroundColor: item.color }" class="category-dot"></span>
                    <span class="pl-1">{{ item.name }}</span>
                </template>
                <template v-else>All</template>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categories: Array,
        selectedCategoryId: [String, Number],
        isAdmin: Boolean
    },
    methods: {
        isSelectedCategory(category) {
            return this.selectedCategoryId && category && this.selectedCategoryId === category.id;
        },
        selectCategory(category) {
            this.$emit('category-selected', category);
        }
    },
};
</script>

<style scoped>
.category-dot {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    display: inline-block;
}
</style>
